<template>
  <section class="hbox stretch">
    <div class="content-header">      
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">运营</a></el-breadcrumb-item>
        <el-breadcrumb-item>买单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">            
        <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="Add" >新增</el-button>
        </el-form-item>
        <el-form-item >
          <el-input   v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="rows" style="width: 100%">
        <el-table-column  fixed  prop="Name"  label="名称" > </el-table-column>
        <el-table-column  prop="StoreName"  label="门店" > </el-table-column>
         <el-table-column  prop="Used"  label="状态" > 
          <template slot-scope="scope">                    
            <p v-if="scope.row.Used==true">使用</p>
            <p v-if="scope.row.Used==false">停止</p>         
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="Edit(scope.row.Id)" type="text" size="small">
            编辑
          </el-button>
          <el-button @click="DeleteRow(scope.row)" type="text" size="small">&nbsp;删除</el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>  
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:10,
        sort:' id desc',
        rows:[],
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      Add:function(){
        this.$router.push({
          name:'consumeActiveInfo',
          params:{
            Id:''
          }
        })
      },
      Edit:function(id){
        this.$router.push({
          name:'consumeActiveInfo',
          params:{
            Id:id
          }
        })
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/ConsumeActive/Index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      
      DeleteRow(row) {
        this.$confirm('确实要该记录吗['+row.Name+']吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/ConsumeActive/Delete',
            data:{
              id: row.Id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.map
  width: 100%;
  height: 200px;
</style>